import React from 'react';

import Link from '../editor/Link'

const EditorSeeMoreLink = props => {

    // render
    return (
        <div>
            {props.children}
            <Link value={props.settings.link} />
        </div>
    );
}


export default EditorSeeMoreLink;